import { getUrl, Request } from "../../request";

export const postQRLocation = ({
  token,
  lat,
  long,
  bill_id,
  confirmed,
  user_car_id,
  current_kilometer,
  order_line_id,
  extra_charge,

} = {}) => {
  const body = { token, lat, long };
  
  if (bill_id) body.bill_id = bill_id;
  if (user_car_id) body.user_car_id = user_car_id;
  if (current_kilometer) body.current_kilometer = current_kilometer;
  if (confirmed !== undefined) body.confirmed = confirmed;
  if (order_line_id) body.order_line_id = order_line_id;
  if (extra_charge !== undefined) body.extra_charge = extra_charge;

  return Request.post(
    getUrl("/api/v1/service_center/qr-code-submit-service/"),
    body
  );
};
